import { useSplitTreatments } from '@splitsoftware/splitio-react';

const BYPASS_SPLIT = import.meta.env.VITE_BYPASS_SPLIT === 'true';

let useFeatureFlagSplit: (a: string, b?: boolean) => boolean | string;

if (BYPASS_SPLIT) {
  useFeatureFlagSplit = (): boolean => {
    return false;
  };
} else {
  useFeatureFlagSplit = (featureFlag: string, isMultivariate?: boolean): boolean | string => {
    // evaluate feature flags with the `useSplitTreatments` hook
    const { treatments, isReady } = useSplitTreatments({ names: [featureFlag] });
    if (!isReady) {
      return false;
    }
    const { treatment } = treatments[featureFlag];
    if (isMultivariate) {
      return treatment;
    } else {
      return treatment === 'on';
    }
  };
}

export { useFeatureFlagSplit };
